<template>

   <div class="responsive-box ">
    <FormViewRun2 :actionVisible="false" :edit="false" :formId="$route.params.id"></FormViewRun2>
   </div>



    <!-- <v-card class="fill-height d-flex flex-column">

        <v-card-title>






        </v-card-title>



    </v-card> -->



</template>
<script>


import FormViewRun2 from '@/components/FormViewRun2.vue';
import FormService from '@/services/FormService';
export default {
    name: "AdminFormOnGosterim",
    components:{FormViewRun2},
    data() {

        return {


        }
    },
    computed: {




    },
    created() {
        this.dataBind();
    },
    methods: {
        dataBind() {
            FormService.AdminFormlari().then((result) => {
                console.log("Formlar", result.data);
                this.forms = result.data;
            }).catch((err) => {

            });
        },







    },



    //   delete(birim) {
    //     return $axios.delete('/Birim/delete/'+birim.id);

    //   }
};
</script>



<style lang="scss">
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    // text-align: center;
    color: #2c3e50;
}

nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}
</style>

<style scoped>
.responsive-box {
    width: 100%;
    max-width: 800px;
    margin: auto;
}
</style>